var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.948 14.612c0-.267.22-.483.492-.483s.492.216.492.483a3.35 3.35 0 0 1-1.012 2.393 3.467 3.467 0 0 1-2.435.995H3.447a3.47 3.47 0 0 1-2.435-.995A3.348 3.348 0 0 1 0 14.612V3.388c0-.932.387-1.78 1.012-2.393A3.467 3.467 0 0 1 3.447 0h9.038c.948 0 1.81.38 2.435.995a3.348 3.348 0 0 1 1.012 2.393c0 .267-.22.483-.492.483a.488.488 0 0 1-.492-.483 2.39 2.39 0 0 0-.724-1.71 2.477 2.477 0 0 0-1.739-.71H3.447c-.676 0-1.292.272-1.739.71a2.392 2.392 0 0 0-.724 1.71v11.224c0 .665.277 1.27.724 1.71a2.477 2.477 0 0 0 1.74.71h9.037c.677 0 1.293-.272 1.74-.71a2.392 2.392 0 0 0 .723-1.71zm1.89-5.97a.479.479 0 0 1 0 .718l-3.669 3.943a.496.496 0 0 1-.691.03.476.476 0 0 1-.031-.68l2.947-3.168H5.917a.488.488 0 0 1-.492-.484c0-.267.22-.483.492-.483h9.477l-2.947-3.17a.475.475 0 0 1 .03-.68c.2-.179.51-.165.692.031l3.668 3.944V8.64z",
    fill: "#B3B3B3",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.793ebb604a2677be4e5a5f6532459821.svg";
export { ForwardRef as ReactComponent };